import initialState from './userActivitiesInitialState';
import actions from './userActivitiesAction';
import mutations from './userActivitiesMutation';

const getters = {
  userActivityTableRecordCount: (state) => {
    const {
      uaTableOptions: {
        itemsPerPage,
        totalItems,
      },
    } = state;
    if (totalItems === 0) {
      return 0;
    }
    return Math.ceil(totalItems / itemsPerPage);
  },
  userActivityTableData: (state) => {
    const {
      uaMembers,
    } = state;
    if (uaMembers.length) {
      const tableData = uaMembers;
      return tableData;
    }
    return [];
  },
};

const userActivitiesModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};
export default userActivitiesModule;
